"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHookForm = void 0;
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("@hookform/resolvers/zod");
const useHookForm = (_a) => {
    var { schema } = _a, rest = __rest(_a, ["schema"]);
    return (0, react_hook_form_1.useForm)(Object.assign(Object.assign({}, rest), { resolver: (0, zod_1.zodResolver)(schema) }));
};
exports.useHookForm = useHookForm;
//# sourceMappingURL=useHookForm.js.map